module.exports = __webpack_public_path__ + "static/img/25.38df017c.png";